import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71d7f32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner_step_box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "4. Адрес и карта местности", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите начало адреса (улица, проспект, ...)          Введите продолжение адреса ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите район                                                              Введите номер дома ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите корпус                                                            Введите литеру или строение ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, " Введите пересечение с домом или павильон если имеется ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "(улица, проспект, шоссе, переулок, бульвар,\n      аллея)",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.save_obj.map_street) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_street]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите продолжение адреса",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeDM.save_obj.map_address) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_address]
      ]),
      _hoisted_4,
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите район",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storeDM.save_obj.map_district) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_district]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите номер дома",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDM.save_obj.map_house) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_house]
      ]),
      _hoisted_6,
      _hoisted_7,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите корпус",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDM.save_obj.map_korpus) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_korpus]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите литеру или строение",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeDM.save_obj.map_build_litera) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_build_litera]
      ]),
      _hoisted_8,
      _hoisted_9,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите пересечение с домом или павильон если имеется",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.storeDM.save_obj.map_cross) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.map_cross]
      ])
    ]),
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      style: _normalizeStyle({ display: _ctx.step_next ? 'block' : 'none' }),
      disabled: !_ctx.step_next,
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 14, _hoisted_14)
  ], 64))
}